<template>
  <div class="app-content-gallery">
    <div v-for="(project, i) in projects" :key="`project-${i}`">
      <span class="project-title mt-4 grey--text text--darken-1">
        <!-- {{ project.title }}
        <span class="font-italic headline">- {{ project.period }}</span> -->
        <v-checkbox
          :color="project.cycle ? 'green' : 'grey'"
          v-model="project.cycle"
          class="d-inline-block ma-0 pa-0 pl-2 caption"
          label="Slide"
          hide-details
        ></v-checkbox>
      </span>

      <div class="app-content-gallery__carousel">
        <v-carousel height="100%" :cycle="project.cycle" interval="4000">
          <v-carousel-item
            v-for="(item, j) in project.items"
            :key="`project-${i}-item-${j}`"
            :src="item.src"
          ></v-carousel-item>
        </v-carousel>
      </div>
    </div>

    <contact-us></contact-us>
  </div>
</template>

<script>
import ContactUs from '@/components/ContactUs'

export default {
  name: 'gallery',
  components: {
    ContactUs
  },
  data: () => ({
    projects: [
      {
        title: 'Project #7',
        period: 'Year 2019',
        items: [
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_01.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_02.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_03.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_04.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_05.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_06.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_07.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_08.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_09.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_10.jpg'
          },
          {
            src: '/img/gallery/project07/foodtrailersandtrucks.com_project07_11.jpg'
          }
        ]
      },
      {
        title: 'Project #6',
        period: 'Year 2019',
        items: [
          {
            src: '/img/gallery/project06/foodtrailersandtrucks.com_project06_01.jpg'
          },
          {
            src: '/img/gallery/project06/foodtrailersandtrucks.com_project06_02.jpg'
          },
          {
            src: '/img/gallery/project06/foodtrailersandtrucks.com_project06_03.jpg'
          },
          {
            src: '/img/gallery/project06/foodtrailersandtrucks.com_project06_04.jpg'
          }
        ]
      },
      {
        title: 'Project #5',
        period: 'Year 2019',
        items: [
          {
            src: '/img/gallery/project05/foodtrailersandtrucks.com_project05_01.jpg'
          },
          {
            src: '/img/gallery/project05/foodtrailersandtrucks.com_project05_02.jpg'
          },
          {
            src: '/img/gallery/project05/foodtrailersandtrucks.com_project05_03.jpg'
          },
          {
            src: '/img/gallery/project05/foodtrailersandtrucks.com_project05_04.jpg'
          }
        ]
      },
      {
        title: 'Project #4',
        period: 'Year 2019',
        items: [
          {
            src: '/img/gallery/project04/foodtrailersandtrucks.com_project04_01.jpg'
          },
          {
            src: '/img/gallery/project04/foodtrailersandtrucks.com_project04_02.jpg'
          },
          {
            src: '/img/gallery/project04/foodtrailersandtrucks.com_project04_03.jpg'
          },
          {
            src: '/img/gallery/project04/foodtrailersandtrucks.com_project04_04.jpg'
          },
          {
            src: '/img/gallery/project04/foodtrailersandtrucks.com_project04_05.jpg'
          },
          {
            src: '/img/gallery/project04/foodtrailersandtrucks.com_project04_06.jpg'
          },
          {
            src: '/img/gallery/project04/foodtrailersandtrucks.com_project04_07.jpg'
          }
        ]
      },
      {
        title: 'Project #3',
        period: 'Year 2019',
        items: [
          {
            src: '/img/gallery/project03/foodtrailersandtrucks.com_project03_01.jpg'
          },
          {
            src: '/img/gallery/project03/foodtrailersandtrucks.com_project03_02.jpg'
          }
        ]
      },
      {
        title: 'Project #2',
        period: 'Year 2019',
        items: [
          {
            src: '/img/gallery/project02/foodtrailersandtrucks.com_project02_01.jpg'
          },
          {
            src: '/img/gallery/project02/foodtrailersandtrucks.com_project02_02.jpg'
          },
          {
            src: '/img/gallery/project02/foodtrailersandtrucks.com_project02_03.jpg'
          },
          {
            src: '/img/gallery/project02/foodtrailersandtrucks.com_project02_04.jpg'
          }
        ]
      },
      {
        title: 'Project #1',
        period: 'Year 2019',
        items: [
          {
            src: '/img/gallery/project01/foodtrailersandtrucks.com_project01_01.jpg'
          },
          {
            src: '/img/gallery/project01/foodtrailersandtrucks.com_project01_02.jpg'
          },
          {
            src: '/img/gallery/project01/foodtrailersandtrucks.com_project01_03.jpg'
          }
        ]
      }
    ]
  }),
  created() {
    this.projects.forEach(p => this.$set(p, 'cycle', false))
  }
}
</script>

<style lang="scss" scoped>
.v-window__next {
  right: 0;
}

.project-title {
  display: block;
  text-align: center;
  font-size: xx-large !important;
  font-weight: 400 !important;
  font-family: fantasy !important;
}
</style>
